var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('img',{class:_vm.$style.toTop,attrs:{"src":require("@/assets/to_top.png"),"alt":""},on:{"click":_vm.handleClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }